import * as zExt from "@redotech/rpc/ext";
import { shopperAgentStrategyIdFormat } from "@redotech/shopper-agent-strategy-id";
import * as z from "zod";

export const updateShopperAgentStrategy = {
  name: "updateShopperAgentStrategy" as const,
  description:
    "Replaces the guidance of one Commerce Agent strategy. Send the full new `guidance` and the strategy's current `mongoDiscountId` from getShopperAgentStrategy, or the discount is cleared. Every step using this strategy changes.",
  mutates: true,
  input: z.object({
    strategyId: shopperAgentStrategyIdFormat.schema,
    /** Wins over the agent fields when both are sent. */
    guidance: z.string().optional(),
    goalGuidance: z.string().optional(),
    outreachGuidance: z.string().optional(),
    mongoDiscountId: zExt.objectId().nullable(),
  }),
  output: z.object({ success: z.boolean() }),
};
